(function(CollectionFiltering, $, undefined){
 
  // This module exists with the assumption that there is an array attached to the window called collectionItems
  // On collection.liquid, it should look something like this:
  //
  //
  // <script>
  //   window.collectionItems = [{% for product in collection.products %}{{ product | json }}{% unless forloop.last %},{% endunless %}{% endfor %}];
  // </script>
 
  // var orderedFilterOptions = ['7 1/4','7 3/8','7 1/2','7 5/8','7 3/4','S-M','L-XL','S/M','L/XL','28','30','32','34','36','38','40','XXS','XS','S','M','L','XL','XXL', 'XXXL'];
  var mixItUpOptions = { 
    controls: {
      enable: false,
      toggleFilterButtons: true, 
      toggleLogic: 'and',
      live: true
    }
  };
  var optionMap = {
    type: 'type',
    Option1: 'color',
    Option2: 'colorfilter',
    occasion: 'occasion',
    skintone: 'skintone'
  };
  var activeFilters = {
    type: [],
    color: [],
    colorfilter: [],
    occasion: [],
    skintone: []
  };

  var swatchSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
    arrows: true
  }

  var getTagValues = function(prefix, tags) {
    var results = [];
    tags.forEach(function(tag, index) {
      if (tag.indexOf(prefix) > -1) {
        results.push(tag.split(prefix, 2)[1]);
      }
    });
    return results;
  };

  var getOptionValues = function(optionNumber, variants) {
    var uniqueValues = [];
    variants.forEach(function(variant, index) {
      if (uniqueValues.indexOf(variant[optionNumber]) === -1) {
        uniqueValues.push(variant[optionNumber]);
      }
    });
    return uniqueValues;
  };

  var returnUniques = function(array) {
    array = array.filter(function (element, index, array) {
      return array.lastIndexOf(element) === index;
    });
    if (array.indexOf('') > -1) {
      array.splice(array.indexOf(''), 1);
    }
    return array;
  };

  var handlize = function(value) {
    return value.replace(/[\s/]/g, '-').toLowerCase();
  };

  var buildNode = function(index, product, option1Values, option2Values, occasionValues, skintoneValues) {
    var $product = $('[data-product-id="'+ product.id +'"]');
    $product
      .attr('data-index', index)
      .attr('data-price', product.price)
      .attr('data-title', product.title);
    option1Values.forEach(function(value, index) {
      if (typeof(value) === 'string') {
        $product.addClass(handlize(product.options[0])+'-'+handlize(value));
      }
    });
    option2Values.forEach(function(value, index) {
      if (typeof(value) === 'string') {
        $product.addClass(handlize(product.options[1])+'-'+handlize(value));
      }
    });
    occasionValues.forEach(function(value, index) {
      if (typeof(value) === 'string') {
        $product.addClass(optionMap.occasion+'-'+handlize(value));
      }
    });
    skintoneValues.forEach(function(value, index) {
      if (typeof(value) === 'string') {
        $product.addClass(optionMap.skintone+'-'+handlize(value));
      }
    });
    // Initiate swatch slider
    $product.find('.small-swatch').slick(swatchSlider);
  };

  var buildFilterSelect = function(name, values, entryPoint) {
    if (values.length <= 0) {
      return false;
    }
    // values = values.sort(function(a, b) {
    //   return (orderedFilterOptions.indexOf(a) - orderedFilterOptions.indexOf(b));
    // });
    if (values.indexOf(null) > -1) {
      values.splice(values.indexOf(null), 1);
    }
    if (values.indexOf('Default Title') > -1) {
      values.splice(values.indexOf('Default Title'), 1);
    }
    var optionValue = optionMap[name];
    var nodes = [];
    values.forEach(function(value, index) {
      var $filterLabel = $('<label />', {'class': 'filter-value', html: value, 'title': value, 'for': handlize(value)});
      var $filterSelect = $('<input />', {'type': 'checkbox', 'class': 'filter-button', 'data-filter-title': value, 'data-filter': '.' + optionValue+'-'+handlize(value), id: handlize(value)});
      var $filterSelectItem = $('<li />', {'style': 'width:100%;', 'class': 'filter-select-wrapper '+ optionValue+'-'+handlize(value), html: [$filterSelect, $filterLabel]});
      nodes.push($filterSelectItem);
    });
    var $filterCollection = $('<ul />', {
      'class': 'refinement_list toggle_content scrollable clearfix',
      'data-option': optionValue,
      'html': nodes
    });
    $(entryPoint).append($filterCollection);
  };

  var clearAllFilters = function(){
    $('.mix-container').mixItUp('filter', '.mix');
  };

  var updateFilterClear = function(text, type) {
    if ($('.clear-filter[data-filter="'+ type +'"]').length > 0) {
      $('.clear-filter[data-filter="'+ type +'"] span').text(text);
    } else {
      var $text = $('<span />', {'text': text});
      var $wrap = $('<a />', {html: $text});
      var $li = $('<li />', {html: $wrap});
      var $filterClear = $('<ul />', {'class': 'left clear-filter', 'data-filter': type, html: $li});
      $('.refinements_selected').append($filterClear);
    }
  };

  var removeFilterClear = function(type) {
    $('.clear-filter[data-filter="'+ type +'"]').remove();
  };

  var handleSortClick = function(self) {
    var value = $(self).text();
    $('.sort').find('.entry.radio.active').removeClass('active');
    $(self).parent().addClass('active');
    $(self).closest('.facet').find('.facetHead').text(value);
    $('.collection-grid').mixItUp('sort',  $(self).data('sort'));
  };

  var handleFilterRemove = function(self) {
    var $filterContainer = $(self).closest('.clear-filter');
    var filter = $filterContainer.attr('data-filter');
    if (filter === 'all') {
      $('.clear-filter').not('[data-filter="all"]').remove();
      $('.refinements_selected').attr('style', 'display:none !important;');
      $('.clear-filter[data-filter="all"]').css({'visibility': 'hidden', 'pointer-events': 'none'});
      activeFilters.team = '';
      activeFilters.size = '';
      activeFilters.color = '';
      $('.attribute.filter').find('.entry.radio.active').removeClass('active');
    } else {
      $filterContainer.remove();
      activeFilters[filter] = '';
      $('.facet[data-option="'+ filter +'"]').find('.entry.radio.active').removeClass('active');
      if ($('.clear-filter').length === 2) {
        $('.refinements_selected').attr('style', 'display:none !important;');
        $('.clear-filter[data-filter="all"]').css({'visibility': 'hidden', 'pointer-events': 'none'});
      }
    }
    var filterString = '.mix'+activeFilters.team+activeFilters.color+activeFilters.size;
    $('.mix-container').mixItUp('filter', filterString);
  };

  var clearAllFilters = function(){
     $('.clear-filters-button').hide();  
     var checkedItems = $('.is-selected');
     checkedItems.prop('checked', false); // Unchecks it
     updateFilterSelect(checkedItems, 'remove');
    $('.filters-selected .new-filter-item').remove();
    $('.mix-container').mixItUp('filter', '.mix');

  };

  var updateFilterSelect = function(self, action) {
    var filterString = '.mix';
    var option = $(self).closest('[data-option]').attr('data-option');
    var value = $(self).attr('data-filter');
    var valueTitle = $(self).attr('data-filter-title');
    if (action === 'add') {
      activeFilters[option].push(value);
      $('<li class="new-filter-item" data-option="'+ option +'"><div data-filter="'+ value +'">'+valueTitle+'</div></li>').appendTo( ".refinements_selected .refinement_list" );
    } else if (action == 'remove') {
      activeFilters[option].splice(activeFilters[option].indexOf(value), 1);
      $('.refinements_selected .refinement_list').find('[data-filter="'+ value +'"]').parent().remove();
    }
    $.each(activeFilters, function(index, filter) {
      filterString += filter.join('');
    });
    if (filterString === '.mix') {
      $('.refinements_selected').hide();  
    } else {
      $('.refinements_selected').show();  
    }
    $('.mix-container').mixItUp('filter', filterString);
  };
  $('.refinements_selected').hide();  

  var initFiltering = function(collection) {
    var filters = {};
    filters.type = [];
    filters.option1 = [];
    filters.option2 = [];
    filters.occasion = [];
    filters.skintone = [];
    if (window.collectionItems) {
      window.collectionItems.forEach(function(product, index) {
        var option1Values = getOptionValues('option1', product.variants);
        var option2Values = getOptionValues('option2', product.variants);
        var occasionValues = getTagValues('occasion:', product.tags);
        var skintoneValues = getTagValues('skintone:', product.tags);
        filters.option1 = filters.option1.concat(option1Values);
        filters.option2 = filters.option2.concat(option2Values);
        filters.occasion = filters.occasion.concat(occasionValues);
        filters.skintone = filters.skintone.concat(skintoneValues);
        filters.type.push(product.type);
        buildNode(index, product, option1Values, option2Values, occasionValues, skintoneValues);
        
        // Remove Free Gift color filters
        for (var i=filters.option2.length-1; i>=0; i--) {
          var optionVal = filters.option2[i];
          if (typeof optionVal == typeof undefined || optionVal == null || optionVal.match(/(\(Freegifts\))/i)) {
            filters.option2.splice(i, 1);
          }
        }
      });
      //buildFilterSelect('type', returnUniques(filters.type), '.refinement_product_type');
      // buildFilterSelect('Option1', returnUniques(filters.option1), '.refinement_color');
      buildFilterSelect('Option2', returnUniques(filters.option2), '.refinement_color_filter');
      buildFilterSelect('occasion', returnUniques(filters.occasion), '.refinement_occasion');
      buildFilterSelect('skintone', returnUniques(filters.skintone), '.refinement_skin_tone');
    }
  };

  var initMixItUp = function() {
    $('.mix-container').mixItUp(mixItUpOptions);
  };

  var bindUIActions = function() {
    $(document).on('change', '.filter-button', function() {
      if ($(this).prop('checked') === true) {
        updateFilterSelect(this, 'add');
        $("html, body").animate({ scrollTop: 0 }, 100);
        $(this).addClass('is-selected');
         $('.clear-filters-button').show();
      } else {
        updateFilterSelect(this, 'remove');
         $(this).removeClass('is-selected');
      }
    });
    $('.mix-container').on('mixEnd', function(e, state){
      var filterResults = $(".filter-result-content");
      if (state.totalShow === 0) {
        filterResults.css({'display':'block'});
        filterResults.text(state.totalShow+' elements match the current filter');
      } else {
        filterResults.css({'display':'none'});
      }
    });

    $('.clear-filters-button').on('click', clearAllFilters);
    
    $(document).on('click', '.new-filter-item div', function(){
      var filterOption = $(this).attr('data-filter');
      var listFilter = $('.refinement_list').find(''+filterOption+'').find('.is-selected');
      console.log(filterOption);
      listFilter.prop('checked', false); // Unchecks it
      updateFilterSelect(listFilter, 'remove');
      return false;
    });
  };

  CollectionFiltering.init = function() {
    bindUIActions();
    initMixItUp();
    initFiltering();
  };

}(window.CollectionFiltering = window.CollectionFiltering || {}, jQuery));